module.exports = __webpack_public_path__ + "static/media/icon_system_rituals_social_youtube.fcb1a967.svg";